import classes from './deleteEmail.scss';
import { getLocalizedStrings } from '../../profileSettingsLocalizedStrings';
const DeleteEmail = (props) => {
  let strings = getLocalizedStrings('NotificationSettings');
  let warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';

 return(
    <div>
      <div className={(props.data.removeEmail.length<34 || props.viewAllMail) ? classes.deleteDataRow : classes.lengthyEmailDeleteRow}>
       <div className={(props.data.removeEmail.length<34 || props.viewAllMail) ? classes.emailData : classes.lengthyEmailDeleteData}>{props.data.removeEmail}</div>
       <span className={classes.mobileButtonAlign}>
       <div className={classes.buttonAlign}>
          <span className={classes.removeButtonAlign}>
            <button className={classes.RemoveButton} onClick={(e,sn) =>props.removeButtonHandler(e,props.email)} disabled={props.data.lastEAPreference}>{strings.deleteButtonValue}</button>
          </span>
          <span className={classes.EditButtonAlign}>
            <button className={classes.CancelButton} onClick={props.removeCancelHandler}>{strings.CancelButtonValue}</button>
          </span>
        </div>
        <div>
         {props.data.emailErr ? 
          <div className={classes.errorBox}> 
            <span><img className={classes.warningImg} src={warningIcon} alt="Warning Icon" /></span>
            <span className={classes.emailError}>
              {props.data.lastEAPreference ? <span>{strings.deleteErrMsg4}</span> : <span>{strings.deleteErrMsg}&nbsp;
              {props.data.preferenceError.join(', ')}{strings.deleteErrMsg2}
              {props.data.preferenceError.join(', ')}{strings.deleteErrMsg3}</span>} {/* ANP2-137 Typo fix in delete email conntact preference on profile setting page */}
            </span>
          </div> : null           
        }
        {props.data.modifyError ? <span className={classes.errorBox}>{strings.errorMsg}</span> : null}
      </div>
  </span>
 </div>
 </div>
  );
};
export default DeleteEmail;